import axios from "@/axios/index";

//State
const state = {
  headers: {},

  session: {},

  user: {},
};

//Getters
const getters = {
  companyId(state) {
    return state.user.company_id;
  },

  headers(state) {
    return state.headers;
  },

  rulesProcessed(state) {
    const helpers = require("@/helpers").default;

    return helpers.processRules(state.user.rules);
  },

  session(state) {
    return state.session;
  },

  user(state) {
    return state.user;
  },

  userId(state) {
    return state.user.id;
  },
};

//Actions
const actions = {
  setHeaders(context, obj) {
    const accessToken = obj["access-token"];
    const client = obj["client"];
    const contentType = obj["content-type"];
    const tokenType = obj["token-type"];
    const expiry = obj["expiry"];
    const uid = obj["uid"];

    localStorage.setItem("ordexa/headers/access-token", accessToken);
    localStorage.setItem("ordexa/headers/client", client);
    localStorage.setItem("ordexa/headers/content-type", contentType);
    localStorage.setItem("ordexa/headers/expiry", expiry);
    localStorage.setItem("ordexa/headers/token-type", tokenType);
    localStorage.setItem("ordexa/headers/uid", uid);

    context.commit("SET_HEADERS", obj);
  },

  setSession(context, obj) {
    const authTime = obj["authTime"];
    const expireAt = obj["expireAt"];

    // localStorage, so new tabs and a reopened browser keep the session until it expires.
    localStorage.setItem("ordexa/session/auth-time", authTime);
    localStorage.setItem("ordexa/session/expire-at", expireAt);

    context.commit("SET_SESSION", obj);
  },

  setUser(context, obj) {
    localStorage.setItem("ordexa/user", JSON.stringify(obj));
    localStorage.setItem("ordexa/user/attachment-url", obj.image_url);
    localStorage.setItem("ordexa/user/email", obj.email);
    localStorage.setItem("ordexa/user/name", obj.name);

    context.commit("SET_USER", obj);
  },

  logout(context) {
    // Invalidate the token on the server too (best effort). The headers are read now, before they are cleared.
    const accessToken = localStorage.getItem("ordexa/headers/access-token");
    if (accessToken) {
      axios
        .delete("/api/v1/auth/sign_out", {
          headers: {
            "access-token": accessToken,
            client: localStorage.getItem("ordexa/headers/client"),
            uid: localStorage.getItem("ordexa/headers/uid"),
            "token-type": localStorage.getItem("ordexa/headers/token-type"),
            expiry: localStorage.getItem("ordexa/headers/expiry"),
          },
          skipGlobalErrorHandler: true,
        })
        .catch(() => {});
    }

    localStorage.removeItem("ordexa/company/id");
    localStorage.removeItem("ordexa/company/hash");

    localStorage.removeItem("ordexa/headers/access-token");
    localStorage.removeItem("ordexa/headers/client");
    localStorage.removeItem("ordexa/headers/content-type");
    localStorage.removeItem("ordexa/headers/expiry");
    localStorage.removeItem("ordexa/headers/token-type");
    localStorage.removeItem("ordexa/headers/uid");

    localStorage.removeItem("ordexa/user");
    localStorage.removeItem("ordexa/user/attachment-url");
    localStorage.removeItem("ordexa/user/email");
    localStorage.removeItem("ordexa/user/name");

    // Rascunhos de anotação (texto clínico) não ficam no aparelho depois de sair.
    Object.keys(localStorage)
      .filter((key) => key.startsWith("ordexa/notes/autosave/"))
      .forEach((key) => localStorage.removeItem(key));

    localStorage.removeItem("ordexa/session/auth-time");
    localStorage.removeItem("ordexa/session/expire-at");
    sessionStorage.removeItem("ordexa/session/auth-time");
    sessionStorage.removeItem("ordexa/session/expire-at");

    context.commit("LOGOUT");
  },
};

//Mutations
const mutations = {
  LOGOUT(state) {
    state.headers = {};
    state.session = {};
    state.user = {};
  },

  SET_HEADERS(state, obj) {
    state.headers = obj;
  },

  SET_SESSION(state, obj) {
    state.session = obj;
  },

  SET_USER(state, obj) {
    state.user = obj;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
